export default {
  add(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/comments/", data)
        .then(resolve)
        .catch(reject);
    });
  },
  interact(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/comments/interaction", data)
        .then(resolve)
        .catch(reject);
    });
  },
  remove(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/comments/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  edit(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .put(`/comments/${data.id}`, data)
        .then(resolve)
        .catch(reject);
    });
  },
  getAll(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/comments/lessons/${params.id}?${queryString}`)
        .then(response => {
          context.commit("addComments", response.data.results);
          context.commit("setCount", response.data.count);
          resolve(response.data);
        })
        .catch(reject);
    });
  }
};
